import { Polyline, Tooltip } from 'react-leaflet';

// AIDEV-NOTE: Polyline tracejada azul para exibir rota otimizada OSRM

interface Props {
  latLngs: [number, number][];
  distance?: string;
  duration?: string;
}

export function RotaPolyline({ latLngs, distance, duration }: Props) {
  if (latLngs.length < 2) return null;

  return (
    <Polyline
      positions={latLngs}
      pathOptions={{
        color: '#1976d2',
        weight: 4,
        opacity: 0.7,
        dashArray: '10,5'
      }}
    >
      {(distance || duration) && (
        <Tooltip sticky>
          {distance && <span>{distance}</span>}
          {distance && duration && <span> - </span>}
          {duration && <span>{duration}</span>}
        </Tooltip>
      )}
    </Polyline>
  );
}
